import { render, staticRenderFns } from "./SmoothPK.vue?vue&type=template&id=1a8af9a6"
import script from "./SmoothPK.vue?vue&type=script&lang=js"
export * from "./SmoothPK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports